import module from 'module';

import templateUrl from './red-flag-config.template.html';
import './red-flag-config.style.less';

class RedFlagConfigView {
  constructor(nav, command, redFlagConfigCache, dict, confirmation) {
    this.nav = nav;
    this.command = command;
    this.redFlagConfigCache = redFlagConfigCache;
    this.dict = dict;
    this.confirmation = confirmation;
  }

  async $onInit() {
    const entries = await this.redFlagConfigCache.toPromise();
    this.config = entries[0];

    this.dict.onLoadingComplete(() => {
      this.types = this.dict['INCOME_SOURCE_TYPE'];
    });
  }

  validateSourceOfIncome() {
    const duplicatedValues = this.config.entries.map(entry => entry.incomeSourceTypeId)
      .filter((value, index, self) => self.indexOf(value) !== index);

    for (let i = 0; i < this.config.entries.length; i++) {
      if (duplicatedValues.includes(this.config.entries[i].incomeSourceTypeId)) {
        this.formEntries['form_' + i]['sourceOfIncome_' + i].$setValidity('unique', false);
      } else {
        this.formEntries['form_' + i]['sourceOfIncome_' + i].$setValidity('unique', true);
      }
    }
  }

  async save() {
    if (this.form.$invalid) {
      return;
    }
    await this.command.execute('UpdateRedFlagConfig', {redFlagConfig: this.config}).toPromise();
    this.redFlagConfigCache.refetch();
  }

  addEntry() {
    this.config.entries.push({
      id: null,
      redFlagConfigId: this.config.id,
      incomeSourceTypeId: null,
      averageMonthlyIncome: null,
      maxAllowedAmount: null
    });
  }

  async removeEntry(idx) {
    const confirmation = await this.confirmation('Do you want to remove this entry?');
    if (!confirmation) {
      return;
    }
    this.config.entries.splice(idx, 1);
  }

  goBack() {
    this.nav.back();
  }
}

module.component('redFlagConfigView', {
  templateUrl,
  controller: RedFlagConfigView
});